import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let appointment_overlay = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'appointment_overlay',
  })
  let selected = useDataValue({
    context: 'tab',
    path: 'selected',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    let isEmergency = appointment_overlay.mode === 'emergency'
    let newData = {
      ...data,
      ...(appointment_overlay.patient_id
        ? {
            patient_id: appointment_overlay.patient_id,
            is_external_patient_id:
              appointment_overlay.is_external_patient_id ?? true,
          }
        : {}),
      ...(appointment_overlay.appointment_id
        ? {
            appointment_id: appointment_overlay.appointment_id,
            is_external_appointment_id:
              appointment_overlay.is_external_appointment_id ??
              (appointment_overlay.appointment_id &&
                appointment_overlay.appointment_id !== 'new'),
          }
        : {}),
      ...(appointment_overlay.treatment_id
        ? {
            treatment_id: appointment_overlay.treatment_id,
            is_external_treatment_id:
              appointment_overlay.is_external_treatment_id ?? true,
          }
        : {}),
      ...(appointment_overlay.appointment_type_id
        ? {
            appointment_type_id: appointment_overlay.appointment_type_id,
            appointment_type_name: appointment_overlay.appointment_type_name,
          }
        : {}),
      ...(appointment_overlay.note && {
        note: appointment_overlay.note,
        add_notes: true,
      }),
      ...(typeof appointment_overlay.duration === 'number' && {
        duration: appointment_overlay.duration,
      }),
      ...(appointment_overlay.patient_new && {
        patient_new: appointment_overlay.patient_new,
      }),
      patient_option:
        appointment_overlay.patient_id || isEmergency
          ? 'existing'
          : (appointment_overlay.patient_option ?? selected.patient_default),
      initial_location: {
        id: selected.location_id,
        vaxiom_id: selected.vaxiom_location_id,
        name: selected.location_name,
        time_zone_id: selected.time_zone_id,
      },
      is_emergency: isEmergency,
    }

    newData.is_external_any =
      newData.is_external_patient_id === true ||
      newData.is_external_appointment_id === true ||
      newData.is_external_treatment_id === true

    return newData
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, appointment_overlay.updated_at])
}
